import React from 'react';
import PropTypes from 'prop-types';

import Steven, { ELEMENT_TYPES } from 'javascripts/helpers/steven';
import { AND, OR } from '../constants';

import { InputRadioGroup } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const TagsOperatorToggle = ({ onChange, selected }) => {
  const handleOnChange = (event) => {
    onChange(event.target.value);

    if (event.target.value === AND) {
      Steven.elementClicked({
        id: 'tags_operator_and_button',
        content: 'And',
        type: ELEMENT_TYPES.BUTTON,
        action: 'tags_operator_changed',
      });
    }
  };

  return (
    <div>
      <InputRadioGroup
        layout="inline"
        selectedValue={selected}
        id="tags-operator-selector"
        label={translate('assetFeed.viewMenu.tagsOperatorToggle.title')}
        options={[
          {
            label: translate(
              'assetFeed.viewMenu.tagsOperatorToggle.orOperator',
            ),
            value: OR,
            testId: 'view_menu__filter-or',
          },
          {
            label: translate(
              'assetFeed.viewMenu.tagsOperatorToggle.andOperator',
            ),
            value: AND,
            testId: 'view_menu__filter-and',
          },
        ]}
        onChange={handleOnChange}
      />
    </div>
  );
};

TagsOperatorToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
};

export default TagsOperatorToggle;
